import { Fragment } from "react";
import { useTranslation } from "react-i18next";

/**
 * Me-remount children saat bahasa berganti, agar teks yang memakai tr()
 * (bukan hook useTranslation) ikut berganti bahasa.
 */
const LanguageKeyed = ({ children }) => {
  const { i18n } = useTranslation();
  return <Fragment key={i18n.language}>{children}</Fragment>;
};

export default LanguageKeyed;
